import { Box, Typography } from '@mui/material'
import React from 'react'

interface EventStringFragmentProps {
  children: string
}

const EventStringFragment: React.FC<EventStringFragmentProps> = (props) => {
  const { children } = props
  return (
    <Box marginX={1}>
      <Typography variant="body1">{children}</Typography>
    </Box>
  )
}

export default EventStringFragment
